import React from 'react'
import moment from 'moment'
import { Divider, Row, Form, Button, Input, Switch, notification, Col, DatePicker, Select } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import Search from '../../components/Search'
import { Link } from 'react-router-dom'

const INIT = {
    name: '',
    last_name: '',
    email: '',
    password: '',
    role_id: null,
    boss_id: null,
    active: true,
    subsidiaries: [],
    work_start_date: '',
}
const { Option } = Select

const UsersCreateContainer = ({ user }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const [subsidiaries, setSubsidiaries] = React.useState([])
    const [currentSearchBooss, setCurrentSearchBooss] = React.useState('')
    const [currentSearchRole, setCurrentSearchRole] = React.useState('')
    const disabled =
        !data.name ||
        !data.last_name ||
        !data.email ||
        !data.password ||
        !data.role_id ||
        !data.subsidiaries.length ||
        !data.work_start_date

    const getSubsidiaries = () => {
        API.get('/api/subsidiaries?pagination=false&filter[active]=1')
            .then(response => {
                setSubsidiaries(response.data)
            })
            .catch(error => {
                console.error('Error en obtener las sucursales', error)
            })
    }
    React.useEffect(() => {
        getSubsidiaries()
    }, [])

    const handleSubmit = e => {
        e.preventDefault()
        setloading(true)
        const newData = { ...data }
        newData.work_start_date = moment(data.work_start_date).format('YYYY/MM/DD')
        newData.created_by = user.id
        API.post('/api/users', newData)
            .then(() => {
                setloading(false)
                setData(INIT)
                notification.success({
                    message: 'El usuario se ha guardado exitosamente',
                })
                setCurrentSearchBooss('')
                setCurrentSearchRole('')
            })
            .catch(error => {
                setloading(false)
                console.error('Error al guardar usuarios', error)
                if (error.response && error.response.data && error.response.data.message) {
                    notification.error({
                        message: error.response.data.message[0],
                    })
                }
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Crear usuario</Divider>
            <Form style={{ maxWidth: '800px', margin: 'auto' }}>
                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser
                    llenados.
                </p>
                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Nombre" className="required" hasFeedback>
                            <Input
                                placeholder="Nombre"
                                value={data.name}
                                required
                                onChange={e => {
                                    setData({ ...data, name: e.target.value.toUpperCase() })
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Apellido" className="required" hasFeedback>
                            <Input
                                placeholder="Apellido"
                                value={data.last_name}
                                onChange={e => {
                                    setData({ ...data, last_name: e.target.value.toUpperCase() })
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Correo" className="required" hasFeedback>
                            <Input
                                placeholder="Correo"
                                value={data.email}
                                type="email"
                                onChange={e => {
                                    setData({ ...data, email: e.target.value.toLocaleLowerCase() })
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Contraseña" className="required" hasFeedback>
                            <Input
                                placeholder="Contraseña"
                                type="password"
                                value={data.password}
                                onChange={e => {
                                    setData({ ...data, password: e.target.value })
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item className="required" label="Perfil">
                            <Search
                                value={currentSearchRole}
                                placeholder="Perfil"
                                onSearch={value => `/api/roles?filter[active]=1&filter[name]=${value}`}
                                onChange={(key, value) => {
                                    setData({ ...data, role_id: key })
                                    setCurrentSearchRole(value.name)
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Jefe directo">
                            <Search
                                value={currentSearchBooss}
                                placeholder="Jefe directo"
                                onSearch={value => `/api/users?filter[active]=1&filter[full_name]=${value}`}
                                label="full_name"
                                onChange={(key, value) => {
                                    setData({ ...data, boss_id: key })
                                    setCurrentSearchBooss(value.full_name)
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item label="Sucursal" className="required">
                    <Select
                        mode="multiple"
                        showSearch
                        labelInValue
                        value={data.subsidiaries}
                        placeholder="Sucursal"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={value => {
                            setData({ ...data, subsidiaries: value })
                        }}
                        style={{ width: '100%' }}
                    >
                        {subsidiaries.map(d => (
                            <Option key={d.id} value={d.id} selected>
                                {d.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Row gutter={24}>
                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Fecha de ingreso laboral" className="required">
                            <DatePicker
                                required
                                value={moment(data.work_start_date)}
                                format="MM/DD/YYYY"
                                onChange={value => {
                                    setData({ ...data, work_start_date: value })
                                }}
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={12} sm={24}>
                        <Form.Item label="Activo" hasFeedback sx={{ display: 'flex' }}>
                            <Switch
                                checked={!!data.active}
                                onChange={value => {
                                    setData({ ...data, active: value })
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>
                    <Form.Item>
                        <Link to="/users">
                            <Button icon="arrow-left">Regresar</Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" icon="save" disabled={disabled} onClick={handleSubmit}>
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>
            </Form>
        </Segment>
    )
}

export default UsersCreateContainer
